import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './versions/en';
import fr from './versions/fr';
import nl from './versions/nl';

Vue.use(VueI18n);

const messages = {
    en: en,
    fr: fr,
    nl: nl
};

let lng;
if (localStorage.getItem('cs-agent-preferredLanguage') !== null) {
    const preferredLanguageFromLocalStorage = localStorage.getItem('cs-agent-preferredLanguage');
    lng = preferredLanguageFromLocalStorage || 'fr';
} else {
    lng = 'fr';
    localStorage.setItem('cs-agent-preferredLanguage', 'fr');
}

const i18n = new VueI18n({
    locale: lng,
    fallbackLocale: 'fr',
    messages
});

export default i18n;